module.exports = __webpack_public_path__ + "img/AnaValeria Blanco.4a1abd63.jpg";